import { SpoolDto } from '../../../types/spool-local';
import { useContext, useEffect, useState } from 'react';
import Loading from '../../../components/Loading';
import RiskDisclaimer from '../../../components/RiskDisclaimer';
import Spools from '../../../components/Spools';
import {
    EmptyDataRow,
    Pagination,
    Table,
    TableRowContainer,
} from '../../../components/Table';
import spoolsContext from '../../../context/spools/spoolsContext';
import themeContext from '../../../context/theme/themeContext';
import useUserSpools from '../../../hooks/web3/vault/useUserSpools';
import Cover from '../../../layout/Cover';
import ActiveSpoolHeaders from './ActiveSpoolsHeader';
import ClaimableSpoolsIncentivizedRewards from './ClaimableSpoolsIncentivizedRewards';

const ActiveSpools = () => {
    const { activeSort, searchTerm, activeFilter, filterData, sort } =
        useContext(spoolsContext);

    const { theme } = useContext(themeContext);

    const { userSpools, isLoading } = useUserSpools();

    const [selectedAccordion, setSelectedAccordion] = useState<string | null>(null);
    const [filteredData, setFilteredData] = useState<SpoolDto[]>([]);

    const toggle = (spoolAddress: string, spool: SpoolDto) => {
        // setSelectedSpool(spool);
        setSelectedAccordion((prev) => (prev === spoolAddress ? null : spoolAddress));
    };

    useEffect(() => {
        if (!userSpools) return;

        const filtered = userSpools
            .filter(
                ({ userData }) =>
                    !!userData?.userCurrentBalance ||
                    !!userData?.pendingDepositAmount ||
                    !!userData?.pendingWithdrawalAmount ||
                    !!userData?.userClaimableAmount ||
                    userData?.userCurrentBalance === 0 // temporary fix for Euler
            )
            .filter((data) => filterData(data, activeFilter, searchTerm));

        setFilteredData(filtered);
    }, [userSpools, activeFilter, searchTerm, filterData]);

    return (
        <div className={`vault-tab active-spools ${theme}`}>
            <Cover useMinHeight={true}>
                <div className='inner__left'>
                    <h2>Your Active Spools</h2>
                    <span>
                        <span className='mobile'>Tap</span>
                        <span>Click</span> a Spool to Expand
                    </span>
                </div>
                <div className='inner__right'>
                    <ClaimableSpoolsIncentivizedRewards />
                    <Table
                        numOfColumns={6}
                        headers={
                            <ActiveSpoolHeaders
                                hasFilteredResults={!!filteredData.length}
                            />
                        }
                        dataLength={userSpools?.length || 0}
                        className='spools-table'
                    >
                        <Loading isLoading={isLoading} text='Loading your Spools...'>
                            <TableRowContainer>
                                {userSpools ? (
                                    filteredData.length ? (
                                        filteredData
                                            .sort((a, b) => sort(a, b, activeSort))
                                            .map((spoolDetails, index) => (
                                                <Spools
                                                    key={index}
                                                    spoolDetails={spoolDetails}
                                                    collapsed={
                                                        selectedAccordion ===
                                                        spoolDetails.address
                                                    }
                                                    toggle={() =>
                                                        toggle(
                                                            spoolDetails.address,
                                                            spoolDetails
                                                        )
                                                    }
                                                    isActiveSpools
                                                />
                                            ))
                                    ) : (
                                        <EmptyDataRow text='No Spools or Risk Models match your search criteria, please try again.' />
                                    )
                                ) : (
                                    <EmptyDataRow text='An unexpected error occurred while loading your Spools.' />
                                )}
                            </TableRowContainer>
                        </Loading>
                        <Pagination rowPerPage={10} />
                    </Table>
                    <RiskDisclaimer updateHeightOnToggle={true} />
                </div>
                {/* <SpoolDeposit />
                <SpoolWithdraw />
                <RiskModelDetails riskModelAddress={riskModelAddress} /> */}
            </Cover>
        </div>
    );
};

export default ActiveSpools;
